<template>
  <AppInstall />
</template>

<script>
import AppInstall from '@/components/base/AppInstall.vue'
export default {
  components: { AppInstall }
}
</script>